<template>
  <validation-observer ref="form">
    <div class="rounded p-4">
      <div class="row">
        <div class="col-md-12 mb-3">
          <em class="fas fa-plus-circle text-orange mr-1" />
          <span class="color-gray-7 font-weight-bold font-16">
            Crear Carta
          </span>
        </div>
        <div class="col-6 col-md-4">
          <div class="form-group">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                id="dd-educative-region"
                v-model="model.educativeRegion"
                custom-error-msg="La región educativa es requerida."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Región Educativa"
                :options="educativeRegions"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
        </div>
        <div class="col-6">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              id="letter-secretary-name"
              v-model="model.secretaryName"
              custom-error-msg="nombre del Secretario(a) asociado(a) es requerido."
              :error="errors[0]"
              label="Secretario(a) asociado(a)"
              :max="120"
              placeholder="Nombre del Secretario(a) Asociado(a)"
            />
          </validation-provider>
        </div>
        <div class="col-md-12">
          <div class="d-flex justify-content-end align-items-center">
            <action-button
              id="modal-btn-cancelar"
              i="fas fa-times-circle"
              variant="outline-danger mr-2"
              @click="cancelHandler()"
            >
              Cancelar
            </action-button>

            <action-button
              i="fa fa-save"
              variant="success pl-4 pr-4"
              @click="saveHandler()"
            >
              Guardar
            </action-button>
          </div>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';

export default {
  name: 'LetterAdd',
  components: {
    CustomDropDown,
    CustomInput,
    ActionButton,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    educativeRegions: {
      type: Array,
      default: () => [],
    },
    secretaryNameTxt: {
      type: String,
      default: '',
    },
  },
  data: function() {
    return {
      model: {
        educativeRegion: null,
        secretaryName: null,
      },
    };
  },
  mounted() {
    this.model.secretaryName = this.secretaryNameTxt;
  },
  methods: {
    cancelHandler() {
      this.$emit('on-cancel');
    },
    async saveHandler() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) return;
      this.$emit('on-save', this.model);
    },
  },
};
</script>
